module.exports = __webpack_public_path__ + "media/q&a.61c1273b.webm";